import React, { useState } from "react";
import "./SearchBar.css";
import { useTranslation } from "react-i18next";

function SearchBar(props) {
  const [input, setInput] = useState("");
  const { t } = useTranslation();

  const handleSearch = () => {
    props.setSearchTerm(input);
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder={t("searchBarbn.placeholder")}
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <button onClick={handleSearch}>{t("searchBarbn.button")}</button>
    </div>
  );
}

export default SearchBar;